import { Dotdigital } from "@fast-simon/common";
const getCookieValue = (e) => { for (var t = document.cookie.split(";"), o = 0; o < t.length; o++) {
    var n = t[o].trim();
    if (0 === n.indexOf(e + "="))
        return decodeURIComponent(n.substring(e.length + 1));
} return undefined; };
export const getDotdigitalID = () => {
    var _a, _b, _c, _d;
    if (Dotdigital === null || Dotdigital === void 0 ? void 0 : Dotdigital.getHasDotdigital()) {
        return (_d = (_c = (_b = (_a = getCookieValue === null || getCookieValue === void 0 ? void 0 : getCookieValue('dm_i')) === null || _a === void 0 ? void 0 : _a.split(",")) === null || _b === void 0 ? void 0 : _b[2]) === null || _c === void 0 ? void 0 : _c.match(/.{8}|.+/g)) === null || _d === void 0 ? void 0 : _d.map((function (e) { return String(parseInt(e, 36)); })).join("");
    }
    return undefined;
};
//# sourceMappingURL=dotdigital.js.map